<template>
  <v-card>
    <!-- <v-card-title>
      <div class="headline">{{ newGstKey ? 'New GST Key' : 'GST Key Review' }}</div>
    </v-card-title>
    <v-divider></v-divider> -->
    <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
      <v-icon>mdi-pencil</v-icon>
      <v-toolbar-title>Edit GST Key </v-toolbar-title>
    </v-toolbar>
    <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
      <v-icon>mdi-magnify</v-icon>
      <v-toolbar-title>Query GST Key </v-toolbar-title>
    </v-toolbar>
    <v-toolbar v-if="newGstKey" dense color="grey lighten-3" flat>
      <v-icon>mdi-plus</v-icon>
      <v-toolbar-title>Create New GST Key</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <message :messages="messages"></message>
      <form>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6 v-if="newGstKey">
              <v-autocomplete v-model="gstKeyForm.gstKeyType" :label="labels.gstKeyType" :items="gstKeyTypeList" item-text="label" item-value="value" :error-messages="errors.collect('gstKeyType')" data-vv-name="gstKeyType" :data-vv-as="labels.gstKeyType" v-validate="'required'"></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{labels.gstKeyType}}</v-subheader>
              <div class="queryValue">{{gstKeyForm.gstKeyType}}</div>
            </v-flex>
            <v-flex xs6 v-if="newGstKey">
              <v-text-field :label="labels.gstKeyCode" v-model="gstKeyForm.gstKeyCode" :error-messages="errors.collect('gstKeyCode')" data-vv-name="gstKeyCode" :data-vv-as="labels.gstKeyCode" v-validate="'required|param|max:1'"></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{labels.gstKeyCode}}</v-subheader>
              <div class="queryValue">{{gstKeyForm.gstKeyCode}}</div>
            </v-flex>
            <v-flex xs12>
              <v-text-field :readonly="queryMode" :label="labels.gstKeyDesc" v-model="gstKeyForm.gstKeyDesc" :error-messages="errors.collect('gstKeyDesc')" data-vv-name="gstKeyDesc" :data-vv-as="labels.gstKeyDesc" v-validate="'required|entry|max:25'"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ gstKeyForm.createdName }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(gstKeyForm.createdDate) }}</div>
            </v-flex>
            <v-flex xs6 v-if="!newGstKey">
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ gstKeyForm.modifiedName }}</div>
            </v-flex>
            <v-flex xs6 v-if="!newGstKey">
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(gstKeyForm.modifiedDate) }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="close">Cancel</v-btn>
      <v-btn color="primary" v-if="!queryMode" text @click.native="doSave">{{ newGstKey ? 'Save' : 'Update' }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'

export default {
  props: {
    'gstKeyForm': Object,
    'newGstKey': Boolean,
    'queryMode': Boolean,
    'reviewMode': Boolean
  },
  data() {
    return {
      labels: {
        gstKeyType: 'GST Key Type',
        gstKeyCode: 'GST Key Code',
        gstKeyDesc: 'Description',
        createdBy: 'Created by',
        createdDate: 'Created date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      promptRemove: false,
      loading: false,
      submitting: false
    }
  },
  computed: {
    gstMenu() {
      return this.$store.state.gstParam.menu
    },
    gstKeyTypeList() {
      return [
        { label: '01 - Country of Risk', value: '01' },
        { label: '02 - Country of Agent', value: '02' },
        { label: '03 - Country of Cedant', value: '03' },
        { label: '04 - Country of Reinsurer', value: '04' },
        { label: '11 - Branch', value: '11' },
        { label: '21 - Agent GST Registration Status', value: '21' }
      ]
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newGstKey) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      this.resetMessages()
      const apiURI = this.gstMenu.createGstKey
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.gstKeyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      this.resetMessages()
      const apiURI = this.gstMenu.updateGstKey
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.gstKeyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    close() {
      this.resetMessages()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>
